import { Injectable } from '@angular/core';
import { Answer } from "./pre-interview-questions-typings";
import { ApiService } from "../api.service";
import { Observable } from "rxjs";
import { PreInterviewQuestion } from "../../typings";
import { HttpParams } from "@angular/common/http";

const yesNoList: string[] = ['Yes', 'No'];

@Injectable({
  providedIn: 'root'
})
export class PreInterviewQuestionsService {

  constructor(private apiService: ApiService) {
  }

  getAllQuestions(orderId: number): Observable<PreInterviewQuestion[]> {
    return this.apiService.httpWrapper<PreInterviewQuestion[]>({
      method: 'GET',
      url: `api/pre-interview/questions/${orderId}`
    });
  }

  getQuestionsForPostingId(jobPostingId: number): Observable<PreInterviewQuestion[]> {
    return this.apiService.httpWrapper<PreInterviewQuestion[]>({
      method: 'GET',
      url: `api/pre-interview/questions/${jobPostingId}/application`
    });
  }

  getQuestionsAndAnswersForPostingId(jobPostingId: number, personId: number): Observable<PreInterviewQuestion[]> {
    const params = new HttpParams()
      .set('personId', String(personId))
      .set('jobPostingId', String(jobPostingId))
    return this.apiService.httpWrapper<PreInterviewQuestion[]>({
      method: 'GET',
      url: `api/pre-interview/questions/read`,
      params
    });
  }

  savePreInterviewAnswers(jobPostingId: number, talentId: number, gatherTrackingId: string, answers :Answer[], talentCountryId: number) {
    return this.apiService.httpWrapper<void>({
      method: 'POST',
      url: `/api/pre-interview/answers/save`,
      body: {
        postingId: jobPostingId,
        talentId: talentId,
        gatherTrackingId: gatherTrackingId,
        answerList: answers,
        talentCountryId: talentCountryId
      }
    });
  }

  submitPreInterviewAnswers(questionIds: number[], jobPostingId: number, personId: number) {
    const params = new HttpParams()
      .set('questionIds', String(questionIds))
      .set('jobPostingId', String(jobPostingId))
      .set('personId', String(personId))
    return this.apiService.httpWrapper<void>({
      method: 'POST',
      url: `/api/pre-interview/answers/submit`,
      params
    });
  }

  savePreInterviewAnswer(jobPostingId: number, personId: number, questionId: number, answer: string) {
    const params = new HttpParams()
      .set('personId', String(personId))
      .set('jobPostingId', String(jobPostingId))
      .set('questionId', String(questionId))
      .set('answer', String(answer));
    return this.apiService.httpWrapper<void>({
      method: 'POST',
      url: `/api/pre-interview/answers/save-one`,
      params
    });
  }

  getSelectedQuestions(orderId: number): Observable<PreInterviewQuestion[]> {
    return this.apiService.httpWrapper<PreInterviewQuestion[]>({
      method: 'GET',
      url: `api/pre-interview/questions/${orderId}/selected`
    });
  }
}
